import { BiometryActionType, BiometryFlow, StartBiometryParams } from '../types'

class Biometry {
  private captchaValue: string
  private userCpf: string
  private callbackRoute: string
  private biometryFlow: BiometryFlow
  private clinicId?: number
  private action?: BiometryActionType

  registerBiometryData({
    captcha,
    cpf,
    callbackRoute,
    biometryFlow,
    clinicId,
    action,
  }: StartBiometryParams) {
    this.captchaValue = captcha
    this.userCpf = cpf
    this.callbackRoute = callbackRoute
    this.biometryFlow = biometryFlow
    this.clinicId = clinicId
    this.action = action
  }

  getBiometryData() {
    return {
      captcha: this.captchaValue,
      cpf: this.userCpf,
      callbackRoute: this.callbackRoute,
      biometryFlow: this.biometryFlow,
      clinicId: this.clinicId,
      action: this.action,
    }
  }
}

export default new Biometry()
